import Button from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import { GuestEntryListItem } from 'legacy/events/types';
import { BsThreeDots } from 'react-icons/bs';

interface EntryDetailProps {
  entry: GuestEntryListItem;
  isAdmitting: boolean;
  onClose: () => void;
  onClickAdmit: (entry: GuestEntryListItem) => void;
  onClickViewDetails: (entry: GuestEntryListItem) => void;
}

const EntryMenu = ({
  isAdmitting,
  entry,
  onClose,
  onClickViewDetails,
  onClickAdmit
}: EntryDetailProps) => (
  <Modal
    visible
    onClose={onClose}
    type={ModalType.ALERT}
    title="More Actions"
    icon={<BsThreeDots size={20} className="text-primary-500" />}
  >
    <div className="pt-4 px-4">
      <div className="pb-4">
        <Button onClick={() => onClickViewDetails(entry)}>View Details</Button>
      </div>
      <Button onClick={() => onClickAdmit(entry)} loading={isAdmitting}>
        Admit
      </Button>
    </div>
  </Modal>
);

export default EntryMenu;
